import React, { useState } from "react"
import { Waypoint } from "react-waypoint"
import styled from "styled-components"

import Anchor from "./anchor"

interface Props {
  label: string
  indexEl: HTMLElement
}

const Year: React.FC<Props> = ({ label, indexEl, children }) => {
  const [isVisible, setIsVisible] = useState(false)

  return (
    <Waypoint
      onEnter={() => {
        setIsVisible(true)
      }}
      onLeave={() => {
        setIsVisible(false)
      }}
    >
      <Content>
        <Anchor indexEl={indexEl} isVisible={isVisible}>
          {label}
        </Anchor>
        {children}
      </Content>
    </Waypoint>
  )
}

export default Year

const Content = styled.div`
  border-bottom: 1px solid #666;
  margin-bottom: 2rem;
`
